import React from 'react'
import { bool } from 'prop-types'
import { LOADER_BLUE } from '../../../utils/constants'

const Loader = ({ fullScreen = false }) => (
  <div className={`loader ${fullScreen ? 'loader--full-screen' : ''}`}>
    <img className='nrd-infinite-loader js-infinite-loader' src={LOADER_BLUE} />
  </div>
)

Loader.propTypes = {
  fullScreen: bool
}

export default Loader